export const getIsStandalonePWA = (): boolean => {
	if (typeof window === "undefined") {
		return false;
	}

	const hasMatchMedia = typeof window.matchMedia === "function";
	const standaloneMatch =
		hasMatchMedia && window.matchMedia("(display-mode: standalone)").matches;
	const overlayMatch =
		hasMatchMedia &&
		window.matchMedia("(display-mode: window-controls-overlay)").matches;
	// iOS Safari exposes navigator.standalone when opened from home screen.
	const iosStandalone =
		typeof window.navigator !== "undefined" &&
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		Boolean((window.navigator as any).standalone) === true;

	return standaloneMatch || overlayMatch || iosStandalone;
};
